import { CourseDef } from '../../../../types';
import L4454341 from './4454341';
import L4454343 from './4454343';
import L4454342 from './4454342';
// import L5234451 from './5234451';
import L5234452 from './5234452';

export const tradeNaPratica: CourseDef = {
  courseTitle: 'TRADE NA PRÁTICA',
  lessons: [L4454341, L4454343, L4454342,
    //  L5234451,
     L5234452],
};

